import { type ReactNode } from "react"
import { H4, H5, H6 } from "@/components/standard/BFText"
import { type Href, router } from "expo-router"
import { Linking } from "react-native"
import { createComponentClickedEvent, track } from "@/analytics/events/base"
import { useScreenName } from "@/hooks/useScreenName"
import ExternalLink from "phosphor-react-native/src/icons/ArrowSquareOut"
import { Horizontal } from "@/components/standard/BFLayout"
import { BFColors } from "@/constants/Colors"

export const BFLink = ({
  dark = false,
  testId,
  url,
  path,
  size,
  showsIcon = false,
  text,
  onPressed,
}: {
  testId: string
  url?: string
  path?: Href
  size: "sm" | "md" | "lg"
  showsIcon?: boolean
  dark?: boolean
  text: string | ReactNode
  onPressed?: () => void
}) => {
  const currentScreen = useScreenName()

  if (!url && !path) {
    throw new Error("BFLink requires either a url or path prop")
  }

  const Link = size === "sm" ? H6 : size === "md" ? H5 : H4

  const onPress = () => {
    track(
      createComponentClickedEvent({
        current_screen: currentScreen,
        component_id: testId,
        component_type: "button",
        component_function: url || (path as string) || "",
        action_taken: "link pressed",
        component_text: String(text),
      })
    )

    if (url) {
      void Linking.openURL(url)
    } else {
      router.navigate(path!)
    }

    void onPressed?.()
  }
  return (
    <Horizontal className="items-center gap-1">
      <Link
        testID={testId}
        onPress={onPress}
        className={"underline"}
        color={dark ? "white" : "primaryLight"}
      >
        {text}
      </Link>
      {showsIcon && <ExternalLink size={16} color={BFColors.calmBlue} />}
    </Horizontal>
  )
}
